import { IKebabOption } from '../Kebab.interfaces';
import { KebabSingleOption } from './KebabSingleOption';

export default KebabSingleOption as any as React.StatelessComponent<IKebabOption>;
